export default __webpack_public_path__ + "static/media/activate-3.f904fcb5.png";